import { render, staticRenderFns } from "./CustomerClaimUpdate.vue?vue&type=template&id=57429b95&"
import script from "./CustomerClaimUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerClaimUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports